module.exports = __webpack_public_path__ + "static/media/Edith_desktop_article_7.43a1d1b3.jpg";